export const IconDownloadArrowDown: {
  name: 'icon_download_arrow_down-c7dfd376b658'
} = {
  name: 'icon_download_arrow_down-c7dfd376b658'
}
